
import Vue, { PropType } from 'vue';
import { mapActions, mapState } from 'pinia';
import { useStore as useProductStore } from '@/stores/product';
import { useStore as useShapeStore } from '@/stores/shape';
import VModal from 'vue-js-modal';
import Checkmark from '@carbon/icons-vue/es/checkmark/16';
// import { ProductVariant } from '@/typings/ProductPrintData';
import { ProductColorSetterType } from '@/setters/typings/common/ProductColorsSetterType';
import VueSlickCarousel from 'vue-slick-carousel';
import { ProductPrintVariant } from '@midocean/webapps-shared-domain';

import ChevronLeft32 from '@carbon/icons-vue/es/chevron--left/32';
import ChevronRight32 from '@carbon/icons-vue/es/chevron--right/32';

Vue.use(VModal, {
  dynamic: true,
  injectModalsContainer: true,
});

export default Vue.extend({
  name: 'SwitchColor',
  components: {
    Checkmark,
    VueSlickCarousel,
    ChevronLeft32,
    ChevronRight32,
  },

  props: {
    productVariants: {
      type: [] as PropType<ProductColorSetterType[]>,
      required: true,
    },
  },

  data() {
    return {
      productName: '',
    };
  },

  computed: {
    ...mapState(useProductStore, [
      'data',
      'isLaserConverter',
      'isDebossingTechnique',
      'isSublimationTechnique',
      'getDebossingColor',
    ]),
  },

  methods: {
    ...mapActions(useProductStore, ['setSelectedVariant']),
    ...mapActions(useShapeStore, [
      'reinitializeShapeVariantImage',
      'convertToBlob',
    ]),

    styleOval(variant: ProductColorSetterType): any {
      return {
        backgroundColor: variant.colorHex,
        outline: '1px solid #f4f4f4',
        border: '5px solid #f4f4f4',
        marginTop: '5px',
        marginLeft: '3px',
        marginRight: '3px',
      };
    },
    styleOvalCheckBox(variant: ProductColorSetterType): any {
      return {
        backgroundColor: variant.colorHex,
        outline: '1px solid #c6c6c6',
        border: '5px solid #f4f4f4',
        margin: '5px',
      };
    },
    changeProductVariantImg(variant: ProductColorSetterType) {
      this.productName = variant.productName;
      let selectedVariant = this.data.variants.find(
        (varImg) => varImg.colour == variant.variantColor
      ) as ProductPrintVariant;

      this.setSelectedVariant(selectedVariant);

      if (
        this.isLaserConverter() ||
        this.isDebossingTechnique() ||
        this.isSublimationTechnique
      ) {
        let textColor = [255, 255, 255];
        if (this.isDebossingTechnique()) {
          textColor = this.getDebossingColor;
        }
        this.reinitializeShapeVariantImage(selectedVariant, textColor);
      }
    },
  },
});
